import { isServer } from '@vue-storefront/core/helpers';

export default {
  data () {
    return {
      windowWidth: !isServer ? window.innerWidth : 0
    }
  },
  mounted () {
    if (!isServer) {
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
      });
    }
  },
  beforeDestroy () {
    if (!isServer) {
      window.removeEventListener('resize', this.onResize);
    }
  },
  methods: {
    onResize () {
      if (!isServer) {
        this.windowWidth = window.innerWidth;
      }
    }
  }
}
